import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { IHistoryFeature } from './history.feature.state';
import { HistoryState } from './history.state';

export const getHistoryState: MemoizedSelector<IHistoryFeature, HistoryState> = createFeatureSelector<HistoryState>(
  nameof<IHistoryFeature>('HistoryFeature')
);

export const getIsLoading = createSelector(getHistoryState, (state: HistoryState) => state.isLoading);
export const getIsSkeletonLoading = createSelector(getHistoryState, (state: HistoryState) => state.isSkeletonLoading);
export const getFailures = createSelector(getHistoryState, (state: HistoryState) => state.failures);
export const getOrderHistory = createSelector(getHistoryState, (state: HistoryState) => state.orderHistory);
